import styled from "styled-components"
import WhiteArrow from "../../svg/built-with-ai-cta-arrow-white.svg"
import BlueArrow from "../../svg/built-with-ai-cta-arrow-blue.svg"
import PinkArrow from "../../svg/built-with-ai-cta-arrow-pink.svg"

export const BuildWithAIContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-top: 65px;
  margin-bottom: 40px;

  @media only screen and (max-width: 1015px) {
    grid-template-columns: 1fr;
    margin-top: 55px;
    gap: 10px;
    margin-bottom: 0;
  }

  @media only screen and (max-width: 760px) {
    margin-top: 105px;
    gap: 42px;
  }
`

export const UpskillWithAIWhiteArrow = styled(WhiteArrow)`
  display: block;

  @media only screen and (max-width: 1065px) {
    height: 20px;
    width: 20px;
  }
`

export const UpskillWithAIBlueArrow = styled(BlueArrow)`
  display: none;

  @media only screen and (max-width: 1065px) {
    height: 20px;
    width: 20px;
  }
`

export const UpskillWithAIPinkArrow = styled(PinkArrow)`
  display: none;

  @media only screen and (max-width: 1065px) {
    height: 20px;
    width: 20px;
  }
`

export const OuterArrowContainer = styled.div`
  @media only screen and (max-width: 760px) {
    margin-top: 15px;
  }
`

export const ArrowContainer = styled.div`
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid ${({ $arrowBorderColor }) => $arrowBorderColor};
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  background-color: ${({ $arrowBgColor }) => $arrowBgColor};

  ${UpskillWithAIWhiteArrow} {
    display: ${({ $defaultArrow }) => $defaultArrow === 'white' ? 'block' : 'none'};
  }

  ${UpskillWithAIBlueArrow} {
    display: ${({ $defaultArrow }) => $defaultArrow === 'blue' ? 'block' : 'none'};
  }

  ${UpskillWithAIPinkArrow} {
    display: ${({ $defaultArrow }) => $defaultArrow === 'pink' ? 'block' : 'none'};
  }

  @media only screen and (max-width: 1065px) {
    width: 45px;
    height: 45px;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  background: ${({ $bgColor }) => $bgColor};
  border-radius: 10px;
  padding: 20px;
  min-height: 110px;
  margin-left: 20px;
  box-shadow: 0 2px 8px rgba(32,24,92,0.1);
  position: relative;
  cursor: pointer;

  &:hover, &:active {
    ${ArrowContainer} {
      background-color: ${({ $arrowBgHoverColor }) => $arrowBgHoverColor};
      border-color: ${({ $arrowBorderHoverColor }) => $arrowBorderHoverColor};

      ${UpskillWithAIWhiteArrow} {
        display: ${({ $hoverArrow }) => $hoverArrow === 'white' ? 'block' : 'none'};
      }

      ${UpskillWithAIBlueArrow} {
        display: ${({ $hoverArrow }) => $hoverArrow === 'blue' ? 'block' : 'none'};
      }

      ${UpskillWithAIPinkArrow} {
        display: ${({ $hoverArrow }) => $hoverArrow === 'pink' ? 'block' : 'none'};
      }
    }
  }

  @media only screen and (max-width: 1050px) {
    margin-bottom: ${(props) => props.firstChild ? "40px" : ""};
  }
  
  @media only screen and (min-width: 761px) and (max-width: 1015px) {
    min-height: 80px;
  }

  @media only screen and (max-width: 760px) {
    max-height: 100px;
    min-height: 100px;
    margin-left: 0;
  }
`;

export const ImageContainer = styled.div`
  position: absolute;
  top: -20px;
  left: -20px;
  width: 196px;
  height: 110px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
  }

  @media only screen and (max-width: 1160px) {
    width: 150px;
    height: 85px;
  }

  @media only screen and (max-width: 760px) {
    top: -65px;
    left: 20px;
  }
`;

export const Content = styled.div`
  flex: 1;
  padding-left: 172px;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 1160px) {
    padding-left: 125px;
  }

  @media only screen and (max-width: 760px) {
    padding-left: 5px;
    padding-top: 20px;
  }
`;

export const CareerPathHeader = styled.div`
  ${({ theme: { typography } }) => typography.desktop.metadata};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.semiBold};
  color: ${({ $textColor }) => $textColor};
  text-transform: uppercase;
  margin-bottom: 10px;

  @media only screen and (max-width: 1200px) {
    ${({ theme: { typography } }) => typography.mobile.metadata};
    font-weight: ${({ theme: { fontWeight } }) => fontWeight.semiBold};
    margin-right: 10px;
    color: ${({ $textColor }) => $textColor};
  }
`;

export const Header = styled.h5`
  ${({ theme: { typography } }) => typography.desktop.h5};
  margin-right: 15px;
  color: ${({ $headerColor }) => $headerColor};

  @media only screen and (max-width: 1200px) {
    ${({ theme: { typography } }) => typography.mobile.h5};
    color: ${({ $headerColor }) => $headerColor};
  }
`;